import { render } from "./PreLoaderComponent.vue?vue&type=template&id=1579068c&scoped=true"
import script from "./PreLoaderComponent.vue?vue&type=script&lang=js"
export * from "./PreLoaderComponent.vue?vue&type=script&lang=js"

import "./PreLoaderComponent.vue?vue&type=style&index=0&id=1579068c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1579068c"]])

export default __exports__